export default __webpack_public_path__ + "static/media/les_andelys05.a3091e84.jpg";